import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetSeedTicketTypeList = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()
	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let path = `/${rolePath}/event/${idx}/seed-ticket-type/list`

		fetchRequest('GET', path)
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 404:
				setAlert('대회 시리즈 데이터가 존재하지 않습니다.')
				break
		}
	})

	return [fetchResult]
}

export default useGetSeedTicketTypeList
